<template>
    <div class="container">
        <!-- Estado de carga -->
        <b-row v-if="isLoading">
            <b-container class="text-center py-5">
                <b-col md="12">
                    <div class="loading-spinner mb-3">
                        <b-spinner variant="primary" style="width: 3rem; height: 3rem;"></b-spinner>
                    </div>
                    <h4 class="text-primary">
                        <b><i>Cargando información...</i></b>
                    </h4>
                </b-col>
            </b-container>
        </b-row>

        <!-- Tabla de ajustes destino -->
        <b-row v-if="!isLoading && ajustDestino && ajustDestino.length > 0">
            <b-container class="pb-3">
                <md-table v-model="ajustDestino" md-card md-fixed-header class="ajustes-table" key="principal-table">
                    <md-table-toolbar>
                        <div style="display: flex; justify-content: center; width: 100%;">
                            <h1 class="md-title">
                                <b><i>{{ labels.titleTbl }} - {{ nombreCompania }}</i></b>
                            </h1>
                        </div>
                    </md-table-toolbar>

                    <md-table-row slot="md-table-row" slot-scope="{ item }"
                        :class="{ 'clickable-row': !readOnly }" @click="handleRowClick(item)">
                        <md-table-cell md-label="Cuenta" class="tbl-cell col-cuenta">
                            {{item.cuenta}}
                        </md-table-cell>

                        <md-table-cell md-label="Descripción" class="tbl-cell col-descripcion text-left">
                            {{ item.descripcion }}
                        </md-table-cell>

                        <md-table-cell md-label="Valor" class="tbl-cell col-valor text-left">
                            {{ formatCurrency(item.valor) }}
                        </md-table-cell>

                        <md-table-cell md-label="Funcional" class="tbl-cell col-funcional text-left">
                            {{ item.funcional }}
                        </md-table-cell>

                        <md-table-cell md-label="Alterna" class="tbl-cell col-alterna text-left">
                            {{ item.alterna }}
                        </md-table-cell>
                        <md-table-cell md-label="Eliminar" class="tbl-cell col-eliminar text-center">
                            <md-button @click.stop="borraCuentasDestino(item.id)"
                                class="md-icon-button md-accent" :disabled="readOnly">
                                <md-icon>delete_outline</md-icon>
                            </md-button>
                        </md-table-cell>
                    </md-table-row>
                </md-table>

                <!-- Botones de acción fuera de la tabla -->
                <b-row class="mt-4">
                    <b-col md="12" class="text-end">
                        <b-button @click="adicionaCuentasDestino()" variant="outline-primary" class="me-2 action-btn"
                            :disabled="readOnly">
                            <b-icon icon="plus-circle" class="me-2"></b-icon>
                            {{ labels.adicionarCuenta }}
                        </b-button>
                        <b-button @click="adicionaCuentaNueva()" variant="primary" class="action-btn"
                            :disabled="readOnly">
                            <b-icon icon="plus-square" class="me-2"></b-icon>
                            {{ labels.adicionarCuentaNueva }}
                        </b-button>
                    </b-col>
                </b-row>
            </b-container>
        </b-row>

        <!-- Mensaje cuando no hay datos -->
        <b-row v-if="!isLoading && (!ajustDestino || ajustDestino.length === 0)">
            <b-container>
                <b-col md="2" class="mx-auto">
                    <div class="success-svg mb-4">
                        <img src="../../assets/imgs/file-2.svg" alt="warning" />
                    </div>
                </b-col>
                <b-col md="12" class="justify-content-around text-center">
                    <span class="h4 text-muted">No hay cuentas de destino registradas.</span>
                </b-col>
                <b-col md="12" class="mt-3 text-center">
                    <b-button @click="adicionaCuentasDestino()" variant="outline-primary" class="me-2 action-btn"
                        :disabled="readOnly">
                        <b-icon icon="plus-circle" class="me-2"></b-icon>
                        {{ labels.adicionarCuenta }}
                    </b-button>
                    <b-button @click="adicionaCuentaNueva()" variant="primary" class="action-btn"
                        :disabled="readOnly">
                        <b-icon icon="plus-square" class="me-2"></b-icon>
                        {{ labels.adicionarCuentaNueva }}
                    </b-button>
                </b-col>
            </b-container>
        </b-row>

        <EditAjustesDest :showEdiAjustDest="showEdiAjustDest" :infoEdit="ajustes" :listCuentas="listCuentas"
            :listCuentasSelMul="listCuentasSelMul" :idCompania="id_compania" :codReporte="codReporte"
            :vigencia="vigencia" :secuencia="ajustDestino[0]?.secuencia" :tipo="ajustDestino[0]?.tipo"
            :tipo_ajuste="ajustDestino[0]?.tipo_ajuste" @reloadTblDest="recargaTabla" @closeModal="cierraModal" />

        <CuentaNuevaDestino :showModal="showModalCuentaNueva" :idCompania="id_compania"
            :codReporte="codReportePrincipal" :vigencia="vigencia" :secuencia="ajustDestino[0]?.secuencia"
            :tipo_ajuste="ajustDestino[0]?.tipo_ajuste" :tipo="ajustDestino[0]?.tipo"
            @closeModal="cierraModalCuentaNueva" @cuentaCreada="cuentaCreada" />
    </div>
</template>

<script>
import Ajustes from '../../services/AjustesConsol'
import EditAjustesDest from './EditAjustesDest.vue';
import CuentaNuevaDestino from './CuentaNuevaDestino.vue';
import AjustesConsol from '../../services/AjustesConsol'
import PlanCuentas from '../../services/PlanCuentas'

export default {
    name:"AjustesDestino",
    props:['ajustDestino','codReporte','id_compania','vigencia', 'nombreCompania', 'readOnly'],
    components:{EditAjustesDest, CuentaNuevaDestino},
    data: () => ({
        ajustes:[],
        showEdiAjustDest:false,
        showModalCuentaNueva:false,
        listCuentas: [],
        listCuentasSelMul: [],
        selectedRow: null,
        isLoading: false,
        codReportePrincipal: null
    }),
    async mounted() {
        this.codReportePrincipal = await this.getReportePrincipal();
    },
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    titleTbl : "Ajustes Destino",
                    cuenta : "Cuenta",
                    descripcion : "Descripción",
                    valor : "Valor",    
                    funcional : "Funcional",    
                    alterna : "Alterna",
                    borrar : "Eliminar",
                    adicionarCuenta: "Adición Cuenta",
                    adicionarCuentaNueva: "Adición Cuenta Nueva"
                }
            }else{
                return {
                    titleTbl : "Destination Settings",
                    cuenta : "Account",
                    descripcion : "Description",
                    valor : "Value",
                    funcional : "Functional",
                    alterna : "Alternate",
                    borrar : "Delete",
                    adicionarCuenta: "Add Account",
                    adicionarCuentaNueva: "Add New Account"
                }
            }
        }
    },
    methods:{
        handleRowClick(item) {
            if (this.readOnly) return;
            this.editAjuste(item.id);
        },

        formatCurrency(value) {
            if (value === 0 || value === "0" || value === null || value === "" || value === undefined) {
                return "";
            }

            return new Intl.NumberFormat('es-ES', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(value);
        },

        cierraModal(val){
            this.showEdiAjustDest = val
        },
        
        cierraModalCuentaNueva(val){
            this.showModalCuentaNueva = val
        },
        
        async editAjuste(id){
            if (this.readOnly) {
                this.$toast.error('La vigencia seleccionada está deshabilitada para edición.');
                return;
            }
            this.isLoading = true;
            try {
                let editAjuste = await AjustesConsol.consulAjusteDestinoById(id)
                this.ajustes = editAjuste.data.ajuste[0]
                this.showEdiAjustDest = true
            } catch (error) {
                console.error('Error al cargar ajuste:', error);
                this.$toast.error('Error al cargar los datos del ajuste');
            } finally {
                this.isLoading = false;
            }
        },

        async getReportePrincipal() {
            const response = await Ajustes.getReportePrincipal();
            return response.data.codigo;
        },
        
        async borraCuentasDestino(id){
            if (this.readOnly) {
                this.$toast.error('La vigencia seleccionada está deshabilitada para eliminar.');
                return;
            }
            if (!confirm('¿Está seguro de que desea eliminar esta cuenta de destino?')) {
                return;
            }

            this.isLoading = true;
            try {
                const val = {
                    id : this.ajustDestino[0]?.secuencia,
                    vigencia : this.vigencia,
                    idCompany : this.id_compania,
                }
                await AjustesConsol.borraCuentasDestino(id)
                this.$toast.success('Cuenta eliminada correctamente');
                this.recargaTabla(val)
            } catch (error) {
                console.error('Error al eliminar la cuenta:', error);
                this.$toast.error('Error al eliminar la cuenta');
            } finally {
                this.isLoading = false;
            }
        },
        
        async adicionaCuentasDestino() {
            if (this.readOnly) {
                this.$toast.error('La vigencia seleccionada está deshabilitada para crear o editar.');
                return;
            }
            try {
                const res = await PlanCuentas.getCuentasPorCompaVigRepor(this.id_compania, this.vigencia, this.codReporte)
                this.listCuentas = res.data.planCuentas
                this.listCuentasSelMul = res.data.planCuentas
                this.ajustes = [{ id_compania: this.ajustDestino[0]?.id_compania }]
                this.showEdiAjustDest = true
            } catch (err) {
                console.error(err)
                this.$toast.error('Error al cargar las cuentas');
            }
        },
        
        adicionaCuentaNueva() {
            if (this.readOnly) {
                this.$toast.error('La vigencia seleccionada está deshabilitada para crear.');
                return;
            }
            this.showModalCuentaNueva = true
        },
        
        async cuentaCreada() {
            this.showModalCuentaNueva = false
            this.isLoading = true;
            try {
                const val = {
                    id: this.ajustDestino[0]?.secuencia,
                    vigencia: this.vigencia,
                    idCompany: this.id_compania,
                }
                await this.recargaTabla(val)
                this.$toast.success('Cuenta creada correctamente');
            } catch (error) {
                console.error('Error al crear la cuenta:', error);
                this.$toast.error('Error al crear la cuenta');
            } finally {
                this.isLoading = false;
            }
        },
        
        async recargaTabla(val) {
            this.showEdiAjustDest = false
            this.isLoading = true;
            try {
                const codReportePrincipal = await this.getReportePrincipal();
                let ajusteDestino = await AjustesConsol.consulAjusteDestino(val.id, val.vigencia, codReportePrincipal)
                this.$emit('update:ajustDestino', ajusteDestino.data.ajustDest)
            } catch (error) {
                console.error('Error al recargar la tabla:', error);
                this.$toast.error('Error al recargar los datos');
            } finally {
                this.isLoading = false;
            }
        }
    }
}
</script>

<style scoped>
.ajustes-table >>> .md-table,
.ajustes-table >>> table {
    width: 100% !important;
    table-layout: fixed !important;
}

.ajustes-table >>> th,
.ajustes-table >>> td,
.ajustes-table >>> .md-table-head,
.ajustes-table >>> .md-table-cell {
    box-sizing: border-box !important;
    padding: 6px 8px !important;
    border: 1px solid #dee2e6 !important;
    white-space: nowrap !important;
    text-overflow: ellipsis;
    overflow: hidden;
    text-align: left !important;
}

.ajustes-table >>> th {
    font-weight: bold;
    background: #f8f9fa;
}

.clickable-row {
    cursor: pointer;
    transition: background-color 0.2s ease;
}

.clickable-row:hover {
    background-color: #f5f5f5 !important;
}

.action-btn {
    border-radius: 8px;
    padding: 12px 24px;
    font-weight: 600;
    font-size: 1.1rem;
    box-shadow: 0 4px 12px rgba(46, 80, 122, 0.3);
    transition: all 0.3s ease;
    min-width: 220px;
    height: 50px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.action-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(46, 80, 122, 0.4);
}

.action-btn:active {
    transform: translateY(0);
    box-shadow: 0 2px 8px rgba(46, 80, 122, 0.3);
}

.action-btn.btn-primary {
    background: linear-gradient(135deg, #2e507a 0%, #3a6496 100%);
    border: none;
}

.action-btn.btn-primary:hover {
    background: linear-gradient(135deg, #3a6496 0%, #4a7bb4 100%);
}

.action-btn.btn-outline-primary {
    border: 2px solid #2e507a;
    color: #2e507a;
    background-color: white;
}

.action-btn.btn-outline-primary:hover {
    background-color: #f8f9fa;
    border-color: #3a6496;
    color: #3a6496;
}

.success-svg {
    text-align: center;
}

.success-svg img {
    width: 80px;
    height: 80px;
}

.col-cuenta      { width: 12% !important; }
.col-descripcion { width: 48% !important; }
.col-valor       { width: 10% !important; }
.col-funcional   { width: 10% !important; }
.col-alterna     { width: 10% !important; }
.col-eliminar    { width: 10% !important; text-align: center !important; }

.ajustes-table >>> td.col-descripcion,
.ajustes-table >>> th.col-descripcion,
.ajustes-table >>> .col-descripcion .md-table-cell {
    white-space: normal !important;
    overflow: visible !important;
    text-overflow: unset !important;
}

.md-icon-button {
    width: 36px !important;
    height: 36px !important;
    min-width: 36px !important;
    min-height: 36px !important;
    padding: 6px !important;
}

</style>
